import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import numeral from "numeral";

// Create styles
const styles = StyleSheet.create({
  body: {
    paddingTop: 40,
    paddingBottom: 40,
    paddingLeft: 30,
    paddingRight: 20
  },
  title: {
    marginBottom: 3,
    fontSize: 16,
    textAlign: "left",
    fontWeight: "800",
  },
  text: {
    margin: 1,
    fontSize: 10,
    textAlign: "justify",
    fontFamily: "Times-Roman",
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  //TABLE-----------------------
   table: {
    margin: "10px 3px",
    width: '100%',
    top: 15,
    paddingBottom: 40
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    margin: "1px"
  },
  borderBottom: {
    borderBottom: '1 solid #0000'
  },
  bold: {
    fontWeight: 'bold',
  },
  rowText: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    fontWeight: 'bold',
  },
  alignLeft: {
    textAlign: 'left'
  },
  alignCenter: {
    textAlign: 'center'
  },
  alignRight: {
    textAlign: 'right'
  },
  row_data: {
    width: '20%',
  },
  row_itemname: {
    width: '20%'
  },
  details: {
    fontWeight: 600,
    fontSize: 10,
    textAlign: "right",
    margin: "2px 10px 2px"
  },
  adj_details:{
    display: 'flex',
    flexDirection: 'row'
  },
  adj_details_header: {
    fontSize: 10
  },
  adj_details_value: {
    fontSize: 10,
    marginLeft: "2px"
  },
  gltrans_inf: {
    fontSize: 11
  },
  bottom_padding: {
    paddingBotom: 10
  },
  upper_padding: {
    paddingTop: 10
  }
});

const GLTransactionViewPdf = (props) => {

  const {
    glid,
    gl_date,
    encoded_by,
    items
  } = props.data;
  
  const header = [
    {title: "ID" },
    {title: "Description" },
    {title: "Account" },
    {title: "Credit" },
    {title: "Debit" },
  ];

  return(
    <Document>
      <Page size="A4" style={styles.body}>
        <View style={styles.title}>
          <Text>GL Transaction</Text>
        </View>
        <View style={styles.details}>
          <Text>{`# ${glid}`}</Text>
        </View>
        <View style={styles.details}>
          <Text>{gl_date}</Text>
        </View>

        <View>
          <View style={[styles.borderBottom, styles.bold, styles.bottom_padding ]}>
            <Text style={[styles.gltrans_inf, styles.bottom_padding]}>
              GL Transaction Information
            </Text>
          </View>
          <View style={[ styles.adj_details, styles.upper_padding ]}>
            <Text style={[styles.adj_details_header, styles.bold]}>
              Encoded By: 
            </Text>
            <Text style={styles.adj_details_value}>
              {encoded_by}
            </Text>
          </View>
        </View> 

        <View style={styles.table}>
          <View style={[styles.row, styles.rowText, styles.borderBottom]}>
            { header.map( row => 
              <Text style={[ styles.rowText, styles.alignCenter, styles.row_itemname ]}>{row.title}</Text>
            )}
          </View>
          <View>
            {
              items.length !== 0 ?
                items.map( (row, i) => 
                  <View key={i} style={styles.row} wrap={false}>
                    <Text style={[styles.row_data, styles.rowText, styles.alignCenter]}>{row.id}</Text>
                    <Text style={[styles.row_data, styles.rowText, styles.alignCenter]}>{row.description}</Text>
                    <Text style={[styles.row_data, styles.rowText, styles.alignCenter]}>{row.account}</Text>
                    <Text style={[styles.row_data, styles.rowText, styles.alignCenter]}>{numeral(row.credit).format('0,0.00')}</Text>
                    <Text style={[styles.row_data, styles.rowText, styles.alignCenter]}>{numeral(row.debit).format('0,0.00')}</Text>
                  </View>
                )
              : ''
            }
          </View>
        </View>


        <Text 
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) => (
          `${pageNumber} / ${totalPages}`
        )} fixed />
      </Page>
    </Document>
  );
}

export default GLTransactionViewPdf;